module.exports = __webpack_public_path__ + "img/buyer-pay-icon.49e27c66.svg";